import { render } from "./DistributorPicker.vue?vue&type=template&id=dfc554a4&scoped=true"
import script from "./DistributorPicker.vue?vue&type=script&lang=js"
export * from "./DistributorPicker.vue?vue&type=script&lang=js"

import "./DistributorPicker.vue?vue&type=style&index=0&id=dfc554a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfc554a4"]])

export default __exports__